import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background: #1a1a2e;
  color: #fff;
  padding: 4rem 0;
  margin-top: 3rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -10px;
    width: 50px;
    height: 3px;
    background: #0066cc;
    
    @media (max-width: 768px) {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const FooterLink = styled(Link)`
  color: #ccc;
  text-decoration: none;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: #0066cc;
  }
`;

const FooterExternalLink = styled.a`
  color: #ccc;
  text-decoration: none;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: #0066cc;
  }
`;

const FooterLogo = styled(Link)`
  font-size: 1.8rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 1rem;
  text-decoration: none;
`;

const FooterDescription = styled.p`
  color: #ccc;
  line-height: 1.8;
  margin-bottom: 1.5rem;
`;

const CopyrightSection = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #ccc;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterLogo to="/">GlobalSushrut</FooterLogo>
          <FooterDescription>
            Pioneering innovations in AI infrastructure, blockchain technology, and physics simulation.
          </FooterDescription>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Projects</FooterTitle>
          <FooterLink to="/mcp-zero">MCP Zero</FooterLink>
          <FooterLink to="/metanode">MetaNode Blockchain</FooterLink>
          <FooterLink to="/zk-physics">Zero Knowledge Physics</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Resources</FooterTitle>
          <FooterExternalLink href="#" target="_blank" rel="noopener noreferrer">Documentation</FooterExternalLink>
          <FooterExternalLink href="#" target="_blank" rel="noopener noreferrer">GitHub</FooterExternalLink>
          <FooterExternalLink href="#" target="_blank" rel="noopener noreferrer">API Reference</FooterExternalLink>
        </FooterSection>
      </FooterContent>
      
      <CopyrightSection>
        <p>&copy; {new Date().getFullYear()} GlobalSushrut. All rights reserved.</p>
      </CopyrightSection>
    </FooterContainer>
  );
};

export default Footer;
